<template>
  <div>
    <nav-bar :title="titlePage"></nav-bar>
    <taskFormSkeleton v-if="loading"> </taskFormSkeleton>
    <div v-else class="mb-5 mobile p-4 layout-tasks">
      <b-form @submit.prevent="errorValidationAndDataSaving" class="input-blue mx-sm-5">
        <div class="mb-3">
          <div class="m-3 mx-4">
            <input
              type="text"
              v-model="local_task.title"
              class="atm-input-title w-100"
              placeholder="Add title*"
              required
            />
          </div>
          <div
            class="d-flex w-100 mb-4 mx-4 flex-wrap justify-content-start items-align-center typeRadioButtons "
          >
            <div v-for="(subType, index) in subTypes" :key="index">
              <input
                :id="subType.name"
                type="radio"
                name="typeSelect"
                :value="subType"
                class="d-none"
                v-model="local_task.type"
              />
              <label :for="subType.name" class="text-wrap">
                {{ subType.name }}
              </label>
            </div>
          </div>
          <div v-if="isSelectProject" class="d-flex w-100 mb-4 px-4 flex-column">
            <label class="font-weight-600 font-size-16 my-2 small-icon">
              Project
            </label>
            <div class="d-flex align-items-baseline">
              <select v-model="local_task.project" class="atm-input text-capitalize w-100">
                <option v-for="project in projects" :value="project.id">
                  {{ project.title }}
                </option>
              </select>
              <b-button
                @click="$router.push({ name: 'createNewProject' })"
                pill
                class="bg-main font-weight-bolder rounded-circle ml-2 p-1"
              >
                <i class="material-icons big-icon align-middle">add</i>
              </b-button>
            </div>
          </div>
          <div class="d-flex w-100 mb-4 px-4 flex-column">
            <label class="font-weight-600 font-size-16 my-2 small-icon">
              Class
            </label>
            <select v-model="local_task.subject" class="atm-input text-capitalize w-100">
              <option value="null">
                Select Class
              </option>
              <option v-for="activeClass in classes" :value="activeClass.id">
                {{ activeClass.name }}
              </option>
            </select>
          </div>
          <div v-if="this.taskTypes !== 'Events'">
            <div class="d-flex  justify-content-center items-align-center w-100 px-4 mt-3 ">
              <label class="font-weight-600 font-size-16 m-0 small-icon">
                When is it due?*
              </label>
              <span class=" ml-auto material-icons">
                event_available
              </span>
            </div>
            <div
              class="px-4 ml-auto w-100 d-flex flex-wrap justify-content-between items-align-center mb-3"
            >
              <input
                v-model="local_task.due_date"
                @change="previousDateNotAllowed"
                type="date"
                class="atm-input-time "
                required
              />
              <input
                v-model="local_task.due_hour"
                @change="previousDateNotAllowed"
                type="time"
                class="atm-input-time"
                required
              />
            </div>
          </div>
          <div class="d-flex justify-content-center items-align-center w-100 px-4 mt-3">
            <label class="font-weight-600 font-size-16 m-0 small-icon">
              {{ textDate }}
            </label>
            <span class=" ml-auto material-icons">
              today
            </span>
          </div>
          <div
            cols="6"
            class="d-flex flex-wrap w-100 px-4 justify-content-between items-align-center mb-3"
          >
            <input
              v-model="local_task.start_date"
              @change="previousDateNotAllowed"
              type="date"
              class="atm-input-time "
              required
            />
            <div class="d-flex gap-1 justify-content-center ml-auto items-align-center">
              <input
                v-model="local_task.start_hour"
                @change="previousDateNotAllowed"
                type="time"
                class="atm-input-time"
                required
              />
              <input
                v-model="local_task.end_hour"
                type="time"
                class="atm-input-time"
                :min="local_task.start_hour"
                required
              />
            </div>
          </div>
          <div
            class="d-flex flex-column w-100 px-4 mt-3 flex-wrap justify-content-start items-align-center "
          >
            <div class="d-flex justify-content-start items-align-center">
              <span class="material-icons-round">
                outlined_flag
              </span>
              <label class="text-capitalize px-1 m-0 font-weight-600">
                Priority
              </label>
            </div>
            <div
              class="d-flex flex-wrap justify-content-start items-align-center w-100 priorityRadioButtons"
            >
              <div v-for="priority in priorities" :key="priority.id">
                <input
                  :id="priority.description"
                  type="radio"
                  name="prioritySelect"
                  :value="priority"
                  v-model="local_task.priority"
                  class="d-none"
                />
                <label
                  :for="priority.description"
                  :class="
                    local_task.priority.id === priority.id
                      ? `bg-pri-${priority.description.toLowerCase()}`
                      : ''
                  "
                  class="d-flex items-align-center"
                >
                  <span
                    class="material-icons-round mr-2"
                    :class="
                      local_task.priority.id === priority.id
                        ? ''
                        : `pri-${priority.description.toLowerCase()}`
                    "
                  >
                    flag
                  </span>
                  <span
                    :class="
                      local_task.priority.id === priority.id
                        ? ''
                        : `pri-${priority.description.toLowerCase()}`
                    "
                  >
                    {{ priority.description }}
                  </span>
                </label>
              </div>
            </div>
          </div>
          <advanceSettingsTask
            :description="local_task.description"
            :taskTypes="taskTypes"
            :repeat="local_task.repeat"
            :repeatOptions="repeatOptions"
            :repeat_date="local_task.repeat_date"
            :notification_type="local_task.notification_type"
            :typesNotifications="typesNotifications"
            :notification_date="local_task.notification_date"
            :file="local_task.file"
            @update:repeat="local_task.repeat = $event"
            @update:description="local_task.description = $event"
            @update:repeatDate="local_task.repeat_date = $event"
            @update:notificationType="local_task.notification_type = $event"
            @update:notificationDate="local_task.notification_date = $event"
            @update:file="local_task.file = $event"
            @update:error="manageError"
          />
          <small
            v-if="errors.length"
            v-for="error in errors"
            :key="error.type"
            class="text-danger d-block"
          >
            <li>
              {{ error.message }}
            </li>
          </small>

          <div class="d-flex justify-content-center items-align-center w-100">
            <b-button
              type="submit"
              class="atm-button text-uppercase bg-main text-light mt-3 mb-4 w-50"
              :disabled="loaderSavingData"
            >
              <b-spinner v-if="loaderSavingData" label="Save" />
              <span v-else>Save</span>
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
    <congrats-modal
      :coins="coinsInfo.coins"
      :points="coinsInfo.points"
      :description="coinsInfo.description"
      @onClose="handleredirectToDefinedRoute"
    ></congrats-modal>
  </div>
</template>
<script>
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import { getClasses } from '@/module/services';
import {
  formatNumericDateCalendar,
  formatHourSelected,
  AdvanceTheTimeByXMinutes,
  datePriorToTheCurrentDate,
} from '@/common/utils/Date';
import taskFormSkeleton from '@/myTasks/components/skeletons/TaskFormSkeleton';
import advanceSettingsTask from '@/myTasks/components/AdvanceSettingsTask';
import CongratsModal from '@/components/Congrats/CongratsModal.vue';
import {
  getTaskInfo,
  getTaskTypes,
  getTaskPriorities,
  getTaskRepeatOptions,
  getTaskTypesNotifications,
  setNewTask,
  setEditTask,
  getAllProjects,
} from '@/myTasks/services';
import { TASK_REPEAT_OPTIONS } from '@/myTasks/constants';

export default {
  components: {
    NavBar,
    CongratsModal,
    taskFormSkeleton,
    advanceSettingsTask,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      loading: false,
      loaderSavingData: false,
      errors: [],
      classes: [],
      taskTypes: 'Task',
      priorities: [],
      subTypes: [],
      repeatOptions: [],
      typesNotifications: [],
      projects: [],
      coinsInfo: {},
      local_task: {
        title: '',
        description: '',
        start_date: '',
        start_hour: '',
        end_hour: '',
        due_date: '',
        due_hour: '',
        project: '',
        type: {},
        subject: null,
        priority: { id: null },
        notification_type: '1',
        notification_date: '',
        repeat: '1',
        repeat_date: '',
        attachment: '',
        file: null,
      },
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    project() {
      return this.$route.params.hasOwnProperty('projectId') ? this.$route.params : null;
    },
    taskId() {
      return this.$route.params.taskId;
    },
    titlePage() {
      if (this.loading) return '';
      const isProject = !!this.project?.projectName;
      const isEvent = this.taskTypes === 'Events';

      if (isProject) return this.project.projectName;
      if (isEvent) return 'My Calendar';

      return this.userIsAParent ? `${this.childName}'s Tasks` : 'My Tasks';
    },
    textDate() {
      return this.taskTypes !== 'Events' ? 'When will you do it?*' : 'Date/Time*';
    },
    childId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    childName() {
      return this.sessionStore.childName;
    },
    isSelectProject() {
      return this.local_task?.type?.name?.toLowerCase() === 'project task';
    },
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        await this.taskRepeatOptions();
        await this.taskTypesNotifications();
        await this.taskPriorities();
        await this.classesLoad();
        await this.taskLoad();
        await this.taskTypesLoad();
        await this.allProjects();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async taskRepeatOptions() {
      try {
        this.repeatOptions = await getTaskRepeatOptions();
      } catch (error) {
        console.error(error);
      }
    },
    async taskTypesNotifications() {
      try {
        this.typesNotifications = await getTaskTypesNotifications();
      } catch (error) {
        console.error(error);
      }
    },
    async taskPriorities() {
      try {
        this.priorities = await getTaskPriorities();
      } catch (error) {
        console.error(error);
      }
    },
    async classesLoad() {
      try {
        this.classes = await getClasses(this.childId);
      } catch (error) {
        console.error(error);
      }
    },
    async taskLoad() {
      try {
        if (this.taskId) {
          this.local_task = await getTaskInfo(this.taskId);
          this.local_task.file = null;
          this.local_task.start_hour = formatHourSelected(this.local_task.start_date);
          this.local_task.end_hour = formatHourSelected(this.local_task.end_date);
        } else {
          this.newTaskHours();
          const dueDate = new Date();
          dueDate.setDate(dueDate.getDate() + 1);
          this.local_task.dueDate = dueDate.toDateString();
        }
        this.local_task.due_hour = formatHourSelected(this.local_task.due_date);
        this.local_task.due_date = formatNumericDateCalendar(this.local_task.dueDate);
        this.local_task.start_date = formatNumericDateCalendar(this.local_task.start_date);
      } catch (error) {
        console.error(error);
      }
    },
    isEventOrTaks(types, targetName) {
      const keys = Object.keys(types);
      const parentKey = keys.find((key) => {
        const array = types[key];
        return array.some((item) => item.name === targetName);
      });

      return parentKey;
    },
    async taskTypesLoad() {
      try {
        const types = await getTaskTypes();
        const type_text = this.local_task.type_text;
        const eventOrTaks = this.isEventOrTaks(types, type_text);
        this.taskTypes = this.$route.params.taskTypes ? this.$route.params.taskTypes : eventOrTaks;
        this.subTypes = this.taskTypes === 'Events' ? types.Events : types.Tasks;
        if (this.taskTypes === 'Events' && !this.$route.params.taskId) {
          this.displayAdvanceSettings = true;
          this.local_task.start_hour = formatHourSelected(this.$route.params.calendarHour);
          this.local_task.end_hour = formatHourSelected(this.$route.params.calendarHour);
          this.local_task.start_date = formatNumericDateCalendar(this.$route.params.calendarDate);
        }
        if (this.local_task.id) {
          this.local_task.type = this.subTypes.filter((item) => {
            return item.name?.toLowerCase().includes(this.local_task.type_text.toLowerCase());
          })[0];
        }
      } catch (error) {
        console.error(error);
      }
    },
    async allProjects() {
      try {
        this.projects = await getAllProjects(this.childId);
        if (this.project) {
          this.local_task.project = this.project.projectId;
          this.local_task.type = this.subTypes.filter((item) => {
            return item.name?.toLowerCase().includes('project task');
          })[0];
        } else if (this.projects.length) {
          this.local_task.project = this.projects[0].id;
        }
      } catch (error) {
        console.error(error);
      }
    },
    generateTaskData(imageData) {
      const formatTask = {
        ...this.local_task,
        isChild: !this.userIsAParent,
        child: this.childId,
        start_date: `${this.local_task.start_date}T${this.local_task.start_hour}`,
        end_date: `${this.local_task.start_date}T${this.local_task.end_hour}`,
        due_date: `${this.local_task.due_date}T${this.local_task.due_hour}`,
        repeat_date: this.local_task.repeat_date ? `${this.local_task.repeat_date}T00:00` : null,
        subject: this.local_task.subject ?? '',
        priority: this.local_task.priority.value,
        project: this.local_task.project,
        type: this.local_task.type.id,
      };
      delete formatTask.file;
      delete formatTask.complete_attachment;

      if (imageData) {
        formatTask.attachment = imageData;
      }

      if (!this.isSelectProject) {
        delete formatTask.project;
      }
      if (!formatTask.notification_date) {
        delete formatTask.notification_date;
      }
      if (this.taskId && !this.local_task.file) {
        delete formatTask.attachment;
      }
      if (formatTask.repeat === TASK_REPEAT_OPTIONS.DOES_NOT_REPEAT) {
        delete formatTask.repeat_date;
        delete formatTask.repeat_date_date;
        delete formatTask.repeat_date_hour;
      }
      return formatTask;
    },
    errorValidationAndDataSaving() {
      this.previousDateNotAllowed();
      this.aTypeHasBeenSelected();
      if (!this.errors.length) {
        this.sendData();
      }
    },
    async sendData() {
      this.loading = true;
      try {
        const taskData = this.generateTaskData(this.local_task.file);
        this.taskId ? this.editTask(taskData) : this.createTask(taskData);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async createTask(taskData) {
      this.loaderSavingData = true;
      try {
        const response = await setNewTask(taskData);
        if (!this.userIsAParent) {
          this.coinsInfo = {
            coins: response.coins,
            points: response.points,
            description: response.description,
            module: response.module,
          };
          this.$bvModal.show('congrats-modal');
          return;
        }
        this.handleredirectToDefinedRoute();
      } catch (error) {
        console.error('taskForm', error);
      } finally {
        this.loaderSavingData = false;
      }
    },
    async editTask(taskData) {
      this.loaderSavingData = true;
      try {
        await setEditTask(this.taskId, taskData);
        this.$router.go(-1);
      } catch (error) {
        console.error('taskForm', error);
      } finally {
        this.loaderSavingData = false;
      }
    },
    handleredirectToDefinedRoute() {
      const toRedirect =
        this.taskTypes === 'Events' ? 'calendar' : this.project ? 'myProjects' : 'task';
      this.$router.push({ name: toRedirect });
    },
    newTaskHours() {
      const start_hour = AdvanceTheTimeByXMinutes();
      const end_hour = AdvanceTheTimeByXMinutes(30);
      this.local_task.start_hour = formatHourSelected(start_hour);
      this.local_task.end_hour = formatHourSelected(end_hour);
    },

    aTypeHasBeenSelected() {
      let error = {
        type: 'typeSelected',
        message: '',
      };
      if (!this.local_task?.type?.id) {
        error.message = 'A task type must be selected';
        this.manageError(error);
        return;
      }
      this.manageError(error);
    },
    previousDateNotAllowed() {
      const errors = [];
      let error = {
        type: 'date',
        message: '',
      };
      if (datePriorToTheCurrentDate(this.local_task.start_date, this.local_task.start_hour)) {
        errors.push('start');
      }
      if (datePriorToTheCurrentDate(this.local_task.due_date, this.local_task.due_hour)) {
        errors.push('due');
      }
      if (errors.length) {
        error.message = `The ${errors.join(', ')} date(s) cannot be earlier than the current date`;
      }
      this.manageError(error);
    },
    manageError(error) {
      const existingErrorIndex = this.errors.findIndex(function(element) {
        return element.type === error.type;
      });
      if (existingErrorIndex !== -1) {
        if (error.message === '') {
          this.errors.splice(existingErrorIndex, 1);
        } else {
          const errors = [...this.errors];
          errors[existingErrorIndex] = error;
          this.errors = errors;
        }
      } else {
        if (error.message !== '') this.errors.push(error);
      }
    },
  },
  watch: {
    'local_task.type': function(val) {
      this.aTypeHasBeenSelected();
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  font-weight: 500;
}
.typeRadioButtons {
  transition: 100ms;

  & input + label {
    position: relative;
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    margin: 0.5rem 0.2rem;
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    &:after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 1.5rem;
      background-color: transparent;
      display: inherit;
    }
  }

  & input:checked + label {
    background-color: #43a5ab;
    color: white;
  }
}

.priorityRadioButtons {
  transition: 100ms;

  & input + label {
    position: relative;
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    margin: 0.5rem 0.2rem;
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    &:after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 1.5rem;
      background-color: transparent;
      display: inherit;
    }
  }

  & input:checked + label {
    color: white;
  }
}

.gap-1 {
  gap: 1rem;
}

.font-weight-600 {
  font-weight: 600;
}

.font-size-16 {
  font-size: 16px !important;
}
</style>
